<template>
  <div class="outline">
    <div class="leftRow">
      <div class="body">
        <img src="@/assets/image/logo.png" class="middleImg" />
        <!-- 中间 -->
        <div style="margin:4.444vh 0px 0px 3.0208vw;height:9.259vh">
          <div style="float:left">
            <div class="english">NEWS</div>
          </div>
          <div class="chinese">资讯</div>
        </div>
        <!-- 底部 -->
        <div class="footerMenu" style="margin-left:1.71875vw">
          <div :class="classNameC" @mouseover="classNameC = 'colAHover'" @mouseout="classNameC = 'colA'" @click="openTypeLise(1)">
            <div class="cha">︻</div>
            <div class="chaFont" style="margin-top:0.74074vh">旅</div>
            <div class="chaFont">游</div>
            <div class="chaFont">新</div>
            <div class="chaFont">闻</div>
            <div class="cha" style="margin-top:0.74074vh">︼</div>
          </div>
          <div :class="classNameD" @mouseover="classNameD = 'colAHover'" @mouseout="classNameD = 'colA'" @click="openTypeLise(2)">
            <div class="cha">︻</div>
            <div class="chaFont" style="margin-top:0.74074vh">景</div>
            <div class="chaFont">区</div>
            <div class="chaFont">新</div>
            <div class="chaFont">闻</div>
            <div class="cha" style="margin-top:0.74074vh">︼</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <Banner></Banner> -->
  </div>
</template>

<script>
import "@/css/switch.css"
import Banner from "../../components/common/banner";
export default {
  name: "OutLine",
  components: { Banner },
  data() {
    return {
      classNameA: "colA",
      classNameB: "colA",
      classNameC: "colA",
      classNameD: "colA"
    };
  },
  methods: {
    openTypeLise(type) {
      this.$store.commit("setChildMenu", 3);
      this.$store.commit("setTabPage", type);
      this.$store.commit("setShowSwitchMenu", false);
      let name = "NewsTab";
      this.$emit("specialtyListFunction", name);
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/newsInfo/newsSwitch.vue